<template>
  <span
    class="BattleTag"
    v-tooltip="tag"
  >
    {{ name }}
  </span>
</template>

<script>
  import { battleTag, battleId } from '@/legacy/lib//template';

  export default {
    props: {
      tag: String
    },

    computed: {
      name () {
        return battleTag (this.tag);
      },

      id () {
        return battleId (this.tag);
      }
    }
  }
</script>